import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function SectionHeader({ eyebrow, title, subtitle, center = true }) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`${center ? 'text-center' : ''} mb-14 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {eyebrow && (
        <p className="section-subheading mb-3 tracking-widest">{eyebrow}</p>
      )}
      <h2 className="section-heading mb-4">{title}</h2>
      {subtitle && (
        <p className="text-slate-500 text-lg max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
      <div className={`mt-5 h-1 w-16 rounded-full bg-gradient-to-r from-primary to-accent ${center ? 'mx-auto' : ''}`} />
    </div>
  );
}
